import {create} from 'zustand';
import {ProfileSectionState} from './types';
import {PROFILE_SECTION} from './constants';

export const useProfileSectionStore = create<ProfileSectionState>(set => ({
	activeSection: PROFILE_SECTION.REGISTRATION_DATA,
	setActiveSection: section => set({activeSection: section}),
	isProfileCompleted: false,
	setIsProfileCompleted: isProfileCompleted => set({isProfileCompleted}),
}));
